<div class="paginate-intermediate">
    <span>{{locale "viewing"}} {{ recordRangeStart }} -<span class="sr-only">{{locale "through"}}</span> {{ recordRangeEnd }} {{locale "of"}} {{ totalRecords }} {{ resultsName }}</span>
	<span id="paging-label" class="sr-only">{{locale "pagination"}}</span>
    <ul class="pagination" role="navigation" aria-labelledby="paging-label">
        <li>
            <button title="{{locale "firstPage"}}" class="first-page btn-tertiary" type="button">
            	{{icon name="caret-line-left" role="presentation" locale="firstPage"}}
            </button>
        </li>
        <li>
            <button title="{{locale "previousPage"}}" class="prev-page btn-tertiary" type="button">
            	{{icon name="caret-left" role="presentation" locale="previousPage"}}
            </button>
        </li>
        {{#each pages}}
            <li>
            	<button title="{{locale "page"}} {{ this }}" class="page-item btn-tertiary" type="button">
            		<span class="sr-only">{{locale "youAreViewing"}} </span>{{ this }}
            	</button>
            </li>
        {{/each}}
        <li>
            <button title="{{locale "nextPage"}}" class="next-page btn-tertiary" type="button">
            	{{icon name="caret-right" role="presentation" locale="nextPage"}}
            </button>
        </li>
        <li>
            <button title="{{locale "lastPage"}}" class="last-page btn-tertiary" type="button">
            	{{icon name="caret-line-right" role="presentation" locale="lastPage"}}
            </button>
        </li>
    </ul>
</div>
